import Page from '@/found/components/table_page';
import Form from '../form/index';

export default {
  name: 'material_maintenance',
  extends: Page,
  data() {
    return {
      params: {},
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
    },
  },
};
